import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "BACK END RATIO D&1 %")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "FHA", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "CONVENTIONAL", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "VA", -1)

import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BackEndRatio',
  props: {
  data: {
    type: Object,
    defaul: null,
  },
},
  setup(__props) {

const props = __props;


const { data } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).fha) = $event))
            }, null, 512), [
              [_vModelText, _unref(data).fha]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).conventional) = $event))
            }, null, 512), [
              [_vModelText, _unref(data).conventional]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_5,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).va) = $event))
            }, null, 512), [
              [_vModelText, _unref(data).va]
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})